import React, { SyntheticEvent, useEffect, useState } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Stack,
    Typography,
    TextField,
    Paper,
    IconButton,
    Box,
    Tooltip,
    Grid,
    FormControl,
    MenuItem,
    Autocomplete
} from '@mui/material'
import { Icon } from '@iconify/react'
import MsiDatagrid from '../custom/MsiDatagridAuto'

import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import axios from 'axios';
import apiUrl from '../../configs/constant';
import Swal from 'sweetalert2';
import DetailInvoice from './invoice/DetailForm'

import { useNavigate } from "react-router-dom";
import { getDesigner, getDoctag } from '../../api/helper'
import { useToast } from '../ToastProvider'
import appInfo from '../../configs/app-info'

/* ===================== TYPES ===================== */
interface Props {
    open: boolean
    contact: any
    onClose: () => void
}

/* ===================== COMPONENT ===================== */

export default function DialogInvoice({
    open,
    contact,
    onClose
}: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const [tabs, setTabs] = useState<string>("0")
    const [listData, setListData] = useState<any[]>([])


    const [openDialog, setOpenDialog] = useState<boolean>(false)

    const [mode, setMode] = useState<string>('')
    const [selectedId, setSelectedId] = useState<any>(null)

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [sddo, setSddo] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const navigate = useNavigate();
    const { showToast, hideToast } = useToast();

    useEffect(() => {
        getData(tabs);
        fetchDoctag()
    }, [])

    const getData = (mode: any) => {
        setListData([])
        let url = apiUrl.apiUrl + '/acc/invoice/list-by-customer'

        axios
            .get(url, {
                params: {
                    sdcust_id: contact?.sdcust_id,
                    mode: mode,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const fetchDoctag = async () => {
        const response = await getDoctag(appInfo.menuId.invoice, cabang, token);
        setListDoctag(response);
    };

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }


    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/acc/invoice/delete/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getData(tabs)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
            {
                title: "Cetak Invoice",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/acc/invoice/pdf/' + row.id, '_blank')
            },
            {
                title: "Hapus Invoice",
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 150,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => {
                        setSelectedId(id)
                        setMode('detail')
                    }}
                />
            ),
        },
    ];

    const ActionButtonsOutstanding = ({ row }: {
        row: any;
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Button
                    variant="contained"
                    color="success"
                    startIcon={<Icon icon="mdi:file-document-plus" />}
                    onClick={() => {
                        // navigate('/acc/invoice/add-do/' + row.id)
                        setSddo(row.id)
                        setValDoctag(null)
                        setOpenDialog(true)
                    }}
                >
                    Buat Invoice
                </Button>
            </Box>
        );
    };

    const actionOutstandingDo = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsOutstanding
                    row={row}
                />
            ),
        },
    ];

    return (

        <>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth={'xl'}>
                {/* <DialogTitle>Order</DialogTitle> */}
                <DialogTitle>
                    {mode === '' && 'Invoice'}
                    {mode === 'add' &&
                        <>
                            <IconButton
                                onClick={() => setMode('')}
                                sx={{ position: 'absolute', left: 10, top: 10 }}
                            >
                                <Icon icon="mdi:chevron-left-circle" />
                            </IconButton>
                            <Typography variant='h5' sx={{ textAlign: 'center' }}>

                                Add Invoice
                            </Typography>
                        </>
                    }
                    {mode === 'detail' &&
                        <>
                            <IconButton
                                onClick={() => setMode('')}
                                sx={{ position: 'absolute', left: 10, top: 10 }}
                            >
                                <Icon icon="mdi:chevron-left-circle" />
                            </IconButton>
                            <Box>
                                <Typography variant='h5' sx={{ textAlign: 'center' }}>
                                    Detail Invoice
                                </Typography>
                                <Typography variant='body1' sx={{ textAlign: 'center' }}>
                                    No. Dokumen : <b>{selectedId}</b>
                                </Typography>
                            </Box>
                        </>
                    }

                    <IconButton
                        onClick={onClose}
                        sx={{ position: 'absolute', right: 10, top: 10 }}
                    >
                        <Icon icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {mode === '' && (
                        <TabContext value={tabs}>
                            <TabList
                                scrollButtons
                                variant='scrollable'
                                onChange={handleChangeTabs}
                                aria-label='forced scroll tabs example'
                            >
                                <Tab value='0' label='Daftar Invoice' />
                                <Tab value='2' label='Outstanding Delivery Order' />
                            </TabList>
                            <TabPanel value='0'>
                                <MsiDatagrid array={listData} actions={actionData} hiddenColumns={['id', 'dokumen', 'is_aktif', 'default_dp', 'default_dp_pesan', 'sdcust_id']} />
                            </TabPanel>
                            <TabPanel value='2'>
                                <MsiDatagrid array={listData} actions={actionOutstandingDo} />
                            </TabPanel>
                        </TabContext>
                    )}

                    {mode === 'detail' && selectedId && (
                        <DetailInvoice
                            id={selectedId}
                            onClose={onClose}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Buat Invoice
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={3} component="form" onSubmit={(e) => {
                        e.preventDefault();
                        // Handle form submission

                        const payload = {
                            sddo_id: sddo,
                            sysdoctag_id: valDoctag,
                        }
                        const url = apiUrl.apiUrl + '/acc/invoice/add-invoice-from-do'
                        axios
                            .post(url, payload, {
                                headers: { Authorization: `Bearer ${token}` }
                            })
                            .then(response => {
                                if (response.data.success) {
                                    const data = response.data.data[0]

                                    showToast(response.data.message, 'success');

                                    setSelectedId(data.id)
                                    setMode('detail')
                                } else {
                                    showToast(response.data.message, 'error');
                                }
                            })
                            .catch(error => {
                                showToast(error.message, 'error');
                            })
                    }}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    label='Pilih Doctag'
                                    value={valDoctag}
                                    onChange={(e) => setValDoctag(e.target.value)}
                                >
                                    <MenuItem value="" disabled>Pilih Doctag</MenuItem>
                                    {listDoctag.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {item.nama}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant='contained' type='submit' disabled={!valDoctag} fullWidth>
                                Buat Invoice
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}